import type { ReactNode, Ref } from 'react';
import type { Table } from '@tanstack/react-table';
import { TableProvider } from './TableContext';
import { joinClasses, tableStyles } from './styles';

interface Props<TData> {
  table: Table<TData>;
  children: ReactNode;
  containerRef?: Ref<HTMLDivElement>;
  containerClassName?: string;
  tableClassName?: string;
}

export default function TableRoot<TData>({
  table,
  children,
  containerRef,
  containerClassName,
  tableClassName,
}: Props<TData>) {
  const { container, table: tableClass } = tableStyles;

  return (
    <TableProvider value={{ table: table as Table<unknown> }}>
      <div
        ref={containerRef}
        className={joinClasses(container, containerClassName)}
      >
        <table className={joinClasses(tableClass, tableClassName)}>
          {children}
        </table>
      </div>
    </TableProvider>
  );
}
